import { render } from "./DocumentAccess.vue?vue&type=template&id=035360b6"
import script from "./DocumentAccess.vue?vue&type=script&lang=js"
export * from "./DocumentAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__